"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiSafeArea = function IconUiSafeArea(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M44 37h-2v2h4v-4h-2v2zm-10.308 0h5.539v2h-5.539zm-8.307 0h5.539v2h-5.539zm-8.308 0h5.539v2h-5.539zM8.77 37h5.539v2H8.77zM6 37H4v-2H2v4h4v-2zM2 25.573h2v6.285H2zm0-9.427h2v6.285H2zm2-5.143h2v-2H2v4h2v-2zm29.692-2h5.539v2h-5.539zm-24.923 0h5.539v2H8.769zm16.615 0h5.539v2h-5.539zm-8.307 0h5.539v2h-5.539zm24.923 2h2v2h2v-4h-4v2zm2 14.57h2v6.285h-2zm0-9.427h2v6.285h-2z"
  }));
};

IconUiSafeArea.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiSafeArea;
exports.default = _default;